'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderDates = exports.isOneOfDays = exports.isSameOrBeforeMonth = exports.isSameOrAfterMonth = exports.isSameMonth = exports.isSameDay = exports.isBetweenDate = exports.isBeforeDay = exports.isAfterDay = exports.getYearNumber = exports.getMonthName = exports.getDayNumber = exports.dateOrNow = exports.addMonths = exports.buildMonthGrid = undefined;

var _luxon = require('luxon');

var fromJSDate = _luxon.DateTime.fromJSDate;
var buildMonthGrid = exports.buildMonthGrid = function buildMonthGrid(date) {
  var startMonth = fromJSDate(date).startOf('month');
  var daysToSkip = (startMonth.weekday - 1) % 7;
  var grid = [];

  for (var i = 0; i < daysToSkip; i++) {
    grid.push(null);
  }

  for (var _i = 0; _i < startMonth.daysInMonth; _i++) {
    grid.push(startMonth.plus({ day: _i }).toJSDate());
  }

  return grid.reduce(function (w, n, i) {
    (w[i / 7 | 0] = w[i / 7 | 0] || []).push(n);
    return w;
  }, []);
};

var addMonths = exports.addMonths = function addMonths(date, months) {
  return date && fromJSDate(date).plus({ months: months }).toJSDate();
};
var dateOrNow = exports.dateOrNow = function dateOrNow(date) {
  return fromJSDate(date || new Date()).toJSDate();
};
var getDayNumber = exports.getDayNumber = function getDayNumber(date) {
  return fromJSDate(date).toFormat('d');
};
var getMonthName = exports.getMonthName = function getMonthName(date) {
  return fromJSDate(date).toFormat('MMMM');
};
var getYearNumber = exports.getYearNumber = function getYearNumber(date) {
  return fromJSDate(date).toFormat('yyyy');
};

var isAfterDay = exports.isAfterDay = function isAfterDay(aDate, bDate) {
  return !!bDate && fromJSDate(aDate).endOf('day') > fromJSDate(bDate).endOf('day');
};

var isBeforeDay = exports.isBeforeDay = function isBeforeDay(aDate, bDate) {
  return !!bDate && isAfterDay(bDate, aDate);
};

var isBetweenDate = exports.isBetweenDate = function isBetweenDate(date, aDate, bDate) {
  return !!aDate && !!bDate && isAfterDay(date, aDate) && isBeforeDay(date, bDate);
};

var isSameDay = exports.isSameDay = function isSameDay(aDate, bDate) {
  return !!bDate && fromJSDate(aDate).hasSame(fromJSDate(bDate), 'day');
};

var isSameMonth = exports.isSameMonth = function isSameMonth(aDate, bDate) {
  return !!bDate && fromJSDate(aDate).hasSame(fromJSDate(bDate), 'month');
};

var isSameOrAfterMonth = exports.isSameOrAfterMonth = function isSameOrAfterMonth(aDate, bDate) {
  return !!bDate && (isSameMonth(aDate, bDate) || fromJSDate(aDate).endOf('month') > fromJSDate(bDate).endOf('month'));
};

var isSameOrBeforeMonth = exports.isSameOrBeforeMonth = function isSameOrBeforeMonth(aDate, bDate) {
  return !!bDate && (isSameMonth(aDate, bDate) || fromJSDate(aDate).endOf('month') < fromJSDate(bDate).endOf('month'));
};

var isOneOfDays = exports.isOneOfDays = function isOneOfDays(date, dates) {
  return dates.some(function (bDate) {
    return isSameDay(date, bDate);
  });
};

var orderDates = exports.orderDates = function orderDates(aDate, bDate) {
  return isAfterDay(aDate, bDate) ? [bDate, aDate] : [aDate, bDate];
};